<template>
  <div :class="[compactWidth ? 'container max-w-expanded-md' : 'container']">
    <div
      v-if="ctaBlockLayout === 'banner'"
      :class="[
        'my-12 md:my-20 mx-auto w-full grid items-stretch overflow-hidden',
        imageOrVideo[0] ? 'grid-cols-1 md:grid-cols-[1fr_2fr]' : 'grid-cols-1',
      ]"
    >
      <div class="relative" v-if="imageOrVideo[0]">
        <CraftAsset
          :alt="imageOrVideo[0].title"
          :asset="imageOrVideo[0]"
          :ratio="4 / 3"
          sizes="(max-width: 767px) 100vw, (max-width: 1279px) 340px, 480px"
          crop="fill"
          :autoplay="false"
          :modal="isVideo"
          :fullscreen="true"
          :controls="false"
          :muted="false"
          :hfull="true"
        />
        <PriceBadge :price="price" :compare-at-price="compareAtPrice" :currency="currency" />
      </div>

      <div class="bg-blackly text-white p-8 md:p-10 flex flex-col items-baseline justify-center">
        <div class="block font-normal fluid-lg leading-tight mb-4">{{ heading }}</div>
        <LinkField v-if="cta[0]" v-bind="cta[0]" class="btn-pill-black">{{ cta[0].text }}</LinkField>
      </div>
    </div>

    <div
      v-else
      :class="[
        'my-12 md:my-20 mx-auto w-full grid items-stretch overflow-hidden',
        imageOrVideo[0] ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1',
      ]"
    >
      <div class="relative" v-if="imageOrVideo[0]">
        <CraftAsset
          :alt="imageOrVideo[0].title"
          :asset="imageOrVideo[0]"
          :ratio="compactWidth ? 4 / 3 : 1 / 1"
          sizes="(max-width: 767px) 100vw, (max-width: 1279px) 512px, 640px"
          crop="fill"
          :autoplay="false"
          :modal="isVideo"
          :fullscreen="true"
          :controls="false"
          :muted="false"
          :hfull="true"
        />
        <PriceBadge :price="price" :compare-at-price="compareAtPrice" :currency="currency" />
      </div>

      <!-- Text Column -->
      <div class="bg-blackly text-white p-8 md:p-10 flex flex-col items-baseline justify-center">
        <div class="block font-normal fluid-lg leading-tight mb-4">{{ heading }}</div>
        <LinkField v-if="cta[0]" v-bind="cta[0]" class="btn-pill-black">{{ cta[0].text }}</LinkField>
      </div>
    </div>
  </div>
</template>

<script>
import LinkField from '~/components/common/LinkField';
import CraftAsset from '~/components/common/CraftAsset';
import PriceBadge from '~/components/common/PriceBadge';

export default defineNuxtComponent({
  components: {
    CraftAsset,
    LinkField,
    PriceBadge,
  },
  props: {
    heading: {
      type: String,
      default: null,
    },
    cta: {
      type: Array,
      default: () => [],
    },
    imageOrVideo: {
      type: Array,
      default: () => [],
    },
    ctaBlockLayout: {
      type: String,
      default: 'banner',
      validator: (value) => ['banner', 'boxed'].includes(value),
    },
    compactWidth: {
      type: Boolean,
      default: false,
    },
    price: {
      type: String,
      default: null,
    },
    compareAtPrice: {
      type: String,
      default: null,
    },
    currencyCode: {
      type: String,
      default: null,
    },
    blockPosition: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isVideo() {
      return this.imageOrVideo?.length && this.imageOrVideo[0]?.kind === 'video';
    },
    currency() {
      if (this.currencyCode) {
        return this.currencyCode;
      }
      const { $getCurrentLocaleConfig } = useNuxtApp();
      return $getCurrentLocaleConfig()?.currency || 'EUR';
    },
  },
});
</script>
